import React, {useState} from 'react';
import b_ from 'b_';

import I18N from 'assets/i18n/brandlift-project';

import {Button} from 'client/common/components/lego';
import {openLink} from 'client/common/utils/window';
import {useUser} from 'client/common/contexts/user';

import {useCreateCreative} from 'client/creatives/hooks/creatives';
import {CreativesBoxType} from 'client/creatives/types';

const i18n = I18N.creatives.creativeLoader;
const b = b_.with('creative-loader');

interface CreativeLoaderProps {
    boxType: CreativesBoxType;
    clientId?: string;
}

export default function CreativeLoader({boxType, clientId}: CreativeLoaderProps) {
    const [createPending, setCreatePending] = useState(false);

    const createCreative = useCreateCreative();
    const user = useUser();

    async function handleCreateCreatives() {
        setCreatePending(true);
        const {
            data: {slug}
        } = await createCreative(boxType, clientId);

        if (slug) {
            setCreatePending(false);
            openLink(`/${boxType}/${slug}`);
        }
    }

    return (
        <div className={b()}>
            <Button
                className={b('button', {type: 'create'})}
                size='m'
                view='action'
                onClick={handleCreateCreatives}
                progress={createPending}
                disabled={user?.info?.authInfo.isAgency && !clientId}
            >
                {i18n.startTest}
            </Button>
        </div>
    );
}
